import { render, staticRenderFns } from "./verlinkungen-editor.vue?vue&type=template&id=45e39d80&scoped=true"
import script from "./verlinkungen-editor.vue?vue&type=script&lang=js"
export * from "./verlinkungen-editor.vue?vue&type=script&lang=js"
import style0 from "./verlinkungen-editor.vue?vue&type=style&index=0&id=45e39d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e39d80",
  null
  
)

export default component.exports